import { PASSPORT_CLIENT } from '../baseURL'
import axios from '../config'

export default {

  // 登录授权
  auth(payload) {
    const { username, password } = payload
    return axios.get(`${PASSPORT_CLIENT}/auth?username=${username}&password=${password.replaceAll('#', '%23')}`, payload)
  },

  // 登录授权
  auth2(payload) {
    return axios.post(`${PASSPORT_CLIENT}/auth`, payload)
  },

  // 验证token有效性
  verifyToken() {
    return axios.get(`${PASSPORT_CLIENT}/auth/verify`)
  },

  // 微信注册绑定
  bindWxApp(payload) {
    return axios.post(`${PASSPORT_CLIENT}/wx/wxapp/bind`, payload)
  }

}
